const divEquipServCard = {
  service: 'Serviço',
  label: 'Inspecionado por:',
  place: 'Local',
  company: 'Empresa',
};

export default divEquipServCard;